export const ADD_OTP_GENERATED: string = "ADD_OTP_GENERATED";
export const ADD_OTP_DELIVERED: string = "ADD_OTP_DELIVERED";
export const ADD_OTP_VERIFIED: string = "ADD_OTP_VERIFIED";
export function addOTPGenerated(OTPGenerated: number): IAddOTPGeneratedActionType {
    return { type: ADD_OTP_GENERATED, OTPGenerated: OTPGenerated};
}
export function addOTPDelivered(OTPDelivered:number): IAddOTPDeliveredActionType {
    return { type: ADD_OTP_DELIVERED, OTPDelivered:OTPDelivered};
}
export function addOTPVerified(OTPVerified:number ): IAddOTPVerifiedActionType {
    return { type: ADD_OTP_VERIFIED, OTPVerified:OTPVerified};
}

interface IAddOTPGeneratedActionType { type:string, OTPGenerated: number}
interface IAddOTPDeliveredActionType { type:string, OTPDelivered:number }
interface IAddOTPVerifiedActionType { type:string, OTPVerified:number }